import axios from "axios";
import React, { useState, useEffect } from "react";
import styles from "../AppBundle.module.css";
import { readableDate } from "../helper/dateToRedable";
import BundleUpload from "../Bundleupload";

export const AppMain = ({selectedApp, setCurrentPage}) => {
  const {
    id,
    app_id,
    app_name,
    package_id,
    app_image_path,
    created_at,
    version,
  } = selectedApp;
  const y = selectedApp;

  console.log("appmain page", selectedApp);

  const [showUploadBundleModal, setShowUploadBundleModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [bundle, setBundle] = useState();
  const [activeBundle, setActiveBundle] = useState(null);

  useEffect(() => {
    fetchBundles();
    fetchActiveBundle();
  }, [selectedApp]);

  const fetchActiveBundle = async () => {
    setLoading(true);
    setBundle(null);
    try {
      console.log("fetching for app id :", app_id);
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.get(
        `${url}/auth/fetchActiveBundle?app_id=${app_id}`,
        {
          withCredentials: true,
        }
      );
      console.log("active bundle", response.data);
      setActiveBundle(response.data.data);
    } catch (e) {
      setFetchError(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchBundles = async () => {
    setLoading(true);
    setBundle(null);
    try {
      console.log("fetching for app id :", app_id);
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.get(
        `${url}/auth/fetchAppVersion?app_id=${app_id}`,
        {
          withCredentials: true,
        }
      );
      console.log(response.data.data);
      setBundle(response.data.data);
    } catch (e) {
      setFetchError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleNextStage = async (bundle_id) => {
    try {
      setLoading(true);
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.put(
        `${url}/auth/updateAppBundleStage`,
        {
          bundle_id,
        },
        {
          withCredentials: true,
        }
      );
      console.log(response.data);
      setBundle((prev) => ({ ...prev, stage: response.data.updated_stage }));
    } catch (e) {
      console.log(e);
    } finally {
      console.log("final");
      setLoading(false);
    }
  };

  const handleBundleUploaded = () => {
    // fetchAppBundles(); // Refresh bundles list
    // fetchActiveBundle(); // Refresh active bundle
  };

  const stageFlow = ["staging", "published", "production"];
  const STAGE_FLOW = ["staging", "published", "production"];

  const getNextStage = (currentStage) => {
    const index = stageFlow.indexOf(currentStage);
    if (index === -1 || index === stageFlow.length - 1) return null;
    return stageFlow[index + 1];
  };

  const StageProgress = ({ currentStage }) => {
    const currentIndex = STAGE_FLOW.indexOf(currentStage);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "20px 0",
        }}
      >
        {STAGE_FLOW.map((stage, index) => {
          const isCompleted = index <= currentIndex;
          const isLast = index === STAGE_FLOW.length - 1;

          return (
            <div
              key={stage}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  background: isCompleted ? "#007bff" : "#ccc",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {index + 1}
              </div>

              <span
                style={{
                  marginLeft: 8,
                  marginRight: 8,
                  fontSize: 13,
                  color: isCompleted ? "#007bff" : "#555",
                  fontWeight: isCompleted ? "bold" : "normal",
                }}
              >
                {stage.toUpperCase()}
              </span>

              {!isLast && (
                <div
                  style={{
                    width: 50,
                    height: 3,
                    background: index < currentIndex ? "#007bff" : "#ccc",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <div
        style={{
          marginTop: 20,
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "2rem", marginBottom: 10 }}>
              {app_name}
            </label>
            <label>{app_id}</label>
            <strong>{package_id}</strong>
            <label>
              <strong>{version}</strong>
            </label>
          </div>
          <button
            onClick={() => {}}
            style={{
              backgroundColor: "white",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
              borderRadius: 12,
            }}
          >
            <img
              src={app_image_path}
              alt="App Icon"
              style={{ width: 80, height: 80, borderRadius: 12 }}
            />
            {app_name}
          </button>
        </div>
      </div>

      {bundle ? (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            gap: 20,
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              border: "1px solid #ccc",
              borderRadius: 10,
              padding: 15,
              textAlign: "center",
              width: "100%",
            }}
          >
            <StageProgress currentStage={bundle.stage} />
            <h4>{bundle.stage.toUpperCase()}</h4>
            <p>
              <strong>Bundle:</strong> {bundle.bundle_version}
            </p>
            <p>
              <strong>App:</strong> {bundle.app_version}
            </p>
            <p>
              <small>{readableDate(bundle.upload_date)}</small>
            </p>

            {getNextStage(bundle.stage) ? (
              <button
                style={{
                  marginTop: 10,
                  padding: "6px 12px",
                  background: "#0066ff",
                  color: "#fff",
                  borderRadius: 6,
                  cursor: "pointer",
                }}
                onClick={() => handleNextStage(bundle.id, bundle.stage)}
              >
                Move to {getNextStage(bundle.stage).toUpperCase()}
              </button>
            ) : (
              <div>
                <p style={{ marginTop: 10, color: "green" }}>
                  ✔ Final Stage Reached
                </p>
                <button
                  style={{
                    marginTop: 10,
                    padding: "6px 12px",
                    background: "#0066ff",
                    color: "#fff",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                  onClick={() => handleNextStage(bundle.id, bundle.stage)}
                >
                  Push to active.
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {/* <div style={{ marginTop: 20 }}>No files uploaded yet</div> */}

          <button
            onClick={() => {
              setShowUploadBundleModal(true);
            }}
            style={{
              width: "100px",
              padding: "10px 20px",
              borderRadius: 8,
              cursor: "pointer",
              border: "none",
              background: "#007bff",
              color: "#fff",
              marginTop: 10,
            }}
          >
            Upload bundle +
          </button>
        </div>
      )}

      {activeBundle ? (
        <div
          style={{
            width: "100%",
            // maxWidth: 450,
            margin: "20px auto",
            background: "white",
            border: "2px solid #2e8b57",
            borderRadius: 12,
            padding: "16px 20px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: 20,
                color: "#2e8b57",
                fontWeight: 600,
              }}
            >
              Active Bundle
            </h2>

            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  background: "#2e8b57",
                  borderRadius: "50%",
                }}
              ></div>
              <p style={{ margin: 0, color: "#2e8b57", fontWeight: 500 }}>
                Live
              </p>
            </div>
          </div>

          <div style={{ marginTop: 12, lineHeight: 1.5 }}>
            <p>
              <strong>Bundle Version:</strong> {activeBundle.bundle_version}
            </p>
            <p>
              <strong>App Version:</strong> {activeBundle.app_version}
            </p>
            <p>
              <strong>Hash:</strong> {activeBundle.bundle_hash}
            </p>
            <p>
              <strong>Stage:</strong>{" "}
              <span style={{ color: "#2e8b57", fontWeight: "bold" }}>
                {activeBundle.stage.toUpperCase()}
              </span>
            </p>
            <p style={{ fontSize: 13, color: "#666" }}>
              Updated on: {readableDate(activeBundle.upload_date)}
            </p>
          </div>

          {/* Footer - Locked */}
          <div
            style={{
              marginTop: 14,
              background: "#f2f2f2",
              border: "1px solid #ccc",
              padding: "10px 12px",
              borderRadius: 6,
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span style={{ fontSize: 16 }}>🔒</span>
            This bundle is active and cannot be modified.
          </div>
        </div>
      ) : (
        <div>No active bundle</div>
      )}

      {showUploadBundleModal && (
        <BundleUpload
          apps={y}
          onBundleUploaded={handleBundleUploaded}
          onClose={() => setShowUploadBundleModal(false)}
        />
      )}

      <button
        onClick={() => {
          setCurrentPage(2);
        }}
        style={{
          width: "100px",
          padding: "10px 20px",
          borderRadius: 8,
          cursor: "pointer",
          border: "none",
          background: "#007bff",
          color: "#fff",
          marginTop: 10,
        }}
      >
        Go to history
      </button>
    </div>
  );
};
